import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Option from "components/Option";

import style from "./style.css";

export default class Select extends Component {
  handleKeyPress(event) {
    if (event.key === "Enter") {
      const onSubmit = this.props.onSubmit;
      onSubmit();
    }
  }
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return (
      <select
        className={finalRootClass}
        onChange={this.props.onChange}
        onKeyPress={this.handleKeyPress.bind(this)}
        defaultValue={this.props.selectedValue}
        name={this.props.name}>
        {typeof this.props.options !== "undefined" && this.props.options.map((value, index) => {
          return <Option key={index} value={index} label={value} />
        })}
        {typeof this.props.options === "undefined" && this.props.children}
      </select>
    );
  }
}

Select.propTypes = {
  onChange: PropTypes.func,
  rootClassname: PropTypes.string,
  selectedValue: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
};

Select.defaultProps = {
  selectedValue: "",
  name: "",
  onChange: function() {},
};



// WEBPACK FOOTER //
// ./src/components/Select/index.js